import dayjs from "dayjs";
import { CUSTOM_VALUE, DateFormat, LAST_60_DAYS_VALUE, LAST_7_DAYS_VALUE, TODAY_VALUE, YESTERDAY_VALUE } from "../constants/dateFormat";

const formatDaysAgo = (days: number) => dayjs().subtract(days, "day").format(DateFormat.YYYY_MM_DD);

const isVaildDate = (date: string | null) => date && dayjs(date).isValid();

export const getDateRangeFromCreatedAt = (
    createdAt: string | undefined,
    customStartDate?: string | null,
    customEndDate?: string | null
): { startDate: string | null; endDate: string | null } => {
    const EMPTY_DATE_RANGE = { startDate: null, endDate: null };
    const today = formatDaysAgo(0)  ;
    if (!createdAt) return EMPTY_DATE_RANGE;
    switch (createdAt) {
        case TODAY_VALUE:
            return { startDate: today, endDate: today };
        case YESTERDAY_VALUE: {
            const yesterday = formatDaysAgo(1);
            return { startDate: yesterday, endDate: yesterday };
        }
        case LAST_7_DAYS_VALUE:
            return {
                startDate: formatDaysAgo(6),
                endDate: today,
            };
        case LAST_60_DAYS_VALUE:
            return {
                startDate: formatDaysAgo(59),
                endDate: today,
            };
        case CUSTOM_VALUE:
            if (isVaildDate(customStartDate ?? null) && isVaildDate(customEndDate ?? null)) {
                return {
                    startDate: dayjs(customStartDate).format(DateFormat.YYYY_MM_DD),
                    endDate: dayjs(customEndDate).format(DateFormat.YYYY_MM_DD),
                };
            }
            return EMPTY_DATE_RANGE;
        default:
            return EMPTY_DATE_RANGE;
    }
};